import React, { forwardRef } from 'react';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import clsx from 'clsx';
import en from 'date-fns/locale/en-US';
import de from 'date-fns/locale/de';
import { useTranslation } from 'react-i18next';

import { Input } from '../common-inputs';

import 'react-datepicker/dist/react-datepicker.css';
import './CommonDatePicker.scss';

registerLocale('en', en);
registerLocale('de', de);

function CommonDatePicker({ dateFormat = 'dd.MM.yyyy', isError = false, placeholder, isClearable, ...rest }) {
  const {
    i18n: { language },
  } = useTranslation();

  return (
    <ReactDatePicker
      className={clsx('common_datepicker', isError && 'common_datepicker--error')}
      wrapperClassName={clsx('common_datepicker-wrapper', isClearable && 'common_datepicker-wrapper--clearable')}
      dateFormat={dateFormat}
      showPopperArrow={false}
      locale={language}
      placeholderText={placeholder}
      customInput={<CustomInput />}
      isClearable={isClearable}
      {...rest}
    />
  );
}

const CustomInput = forwardRef(({ value, onClick, placeholder }, ref) => {
  return <Input inputRef={ref} size='sm' value={value} onClick={onClick} isReadOnly placeholder={placeholder} />;
});
CustomInput.displayName = 'DatePickerInput';

export default CommonDatePicker;
